import React from "react";

import DeleteRow from "~/components/Icons/svg/DeleteRow";
import DownloadRow from "~/components/Icons/svg/DownloadRow";
import EditRow from "~/components/Icons/svg/EditRow";
import SettingsRow from "~/components/Icons/svg/SettingsRow";
import ViewDetailsIcon from "~/components/Icons/svg/ViewDetailsIcon";

import s from "~/shared/ui/TableV2/ui/TableV2.less";

interface DefaultRowControlProps<RecordType> {
  record: RecordType;
  onRowEdit?: (record: RecordType) => void;
  onRowDelete?: (record: RecordType) => void;
  onViewDetails?: (record: RecordType) => void;
  onDownload?: (record: RecordType) => void;
  downloadButtonTitle?: string;
  onRowSettings?: (record: RecordType) => void;
  prefix?: React.ReactNode | ((record: RecordType) => React.ReactNode);
  extra?: React.ReactNode | ((record: RecordType) => React.ReactNode);
}

export const DefaultRowControl = <RecordType,>({
  record,
  onRowEdit,
  onRowDelete,
  onViewDetails,
  onDownload,
  downloadButtonTitle,
  onRowSettings,
  prefix,
  extra,
}: DefaultRowControlProps<RecordType>) => {
  const status = (record as { status?: string }).status;
  const isRemoved = status === "removed";

  const handleEdit = () => {
    onRowEdit?.(record);
  };

  const handleDelete = () => {
    onRowDelete?.(record);
  };

  const handleViewDetails = () => {
    onViewDetails?.(record);
  };

  const handleDownload = () => {
    onDownload?.(record);
  };

  const handleSettings = () => {
    onRowSettings?.(record);
  };

  return (
    <div
      className={s.rowControls}
      onClick={(e) => e.stopPropagation()}
      onMouseDown={(e) => e.stopPropagation()}
    >
      {prefix != null
        ? typeof prefix === "function"
          ? (prefix as (r: RecordType) => React.ReactNode)(record)
          : prefix
        : null}
      {typeof onViewDetails === "function" && (
        <div className={s.rowControlBtn} onClick={handleViewDetails}>
          <ViewDetailsIcon />
        </div>
      )}
      {typeof onRowEdit === "function" && (
        <div className={s.rowControlBtn} onClick={handleEdit}>
          <EditRow />
        </div>
      )}
      {typeof onDownload === "function" && (
        <div
          className={s.rowControlBtn}
          onClick={handleDownload}
          title={downloadButtonTitle}
          role="presentation"
        >
          <DownloadRow />
        </div>
      )}
      {typeof onRowSettings === "function" && (
        <div className={s.rowControlBtn} onClick={handleSettings}>
          <SettingsRow />
        </div>
      )}
      {!isRemoved && typeof onRowDelete === "function" && (
        <div className={s.rowControlBtn} onClick={handleDelete}>
          <DeleteRow />
        </div>
      )}
      {extra != null
        ? typeof extra === "function"
          ? (extra as (r: RecordType) => React.ReactNode)(record)
          : extra
        : null}
    </div>
  );
};
